import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService {
  //#region Inputs, Outputs, ViewChilds
  //#endregion Inputs, Outputs, ViewChilds

  //#region Public Variables
  public IsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public IsLoadingObs: Observable<boolean> = this.IsLoading.asObservable();
  //#endregion Public Variables

  //#region Private Variables
  private requestCount: number = 0;
  //#endregion Private Variables

  //#region Properties
  //#endregion Properties

  //#region Constructor and Angular Life Cycle
  //#endregion Constructor and Angular Life Cycle

  //#region Event Handlers
  //#endregion Event Handlers

  //#region Public Methods

  public Hide(): void {
    if (this.requestCount === 1) {
      this.IsLoading.next(false);
    }

    this.requestCount--;
  }

  public Show(): void {
    if (this.requestCount === 0) {
      this.IsLoading.next(true);
    }

    this.requestCount++;
  }
  //#endregion Public Methods

  //#region Private Methods
  //#endregion Private Methods
}
